<template>
    <div>
        <b-button variant="primary" class="btn-block-xs-only" @click="startSavePhone"><i class="fa fa-plus"></i> Agregar teléfono</b-button>
        <b-table responsive v-if="tableData.length" striped hover :items="tableData" :fields="fields">
            <template slot="actions" slot-scope="{ item }">
                <b-button size="sm" variant="primary" title="modificar teléfono" @click="startUpdatePhone(item)"><i class="fa fa-pencil"></i></b-button>
                <b-button size="sm" variant="danger" title="Eliminar teléfono" @click="startRemovePhone(item)"><i class="fa fa-trash"></i></b-button>
            </template>
        </b-table>
        <div v-else>
            <b-alert show variant="info">Actualmente no tiene guardado ningun contacto, ¡Agregue uno!</b-alert>
        </div>

        <!-- inicio de pop ups -->
        <app-pop-up title="Formulario teléfono" id="store-phone-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <app-phone-store-form :store="store" :myPhone="selectedPhone" :onSave="onSave" :onEdit="onEdit" />
            </div>
            <div slot="buttons">
                <b-button variant="confirm" :disabled="inProgress" class="btn-block-xs-only" @click="$bus.$emit('store-phone-form.save')"><i class="fa fa-floppy-o"></i> Guardar teléfono</b-button>
            </div>
        </app-pop-up>
        
        <app-pop-up title="Confirmación" id="store-phone-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar este teléfono?</h2></div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deletePhone(selectedPhone)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>
        </app-pop-up>
        <!-- Fin pop up's -->
    </div>
</template>

<script>
import PhoneStoreForm from './PhoneStoreForm/PhoneStoreForm';
import storesRepository from '../../../../repositories/stores.repository.js';
import {mapGetters, mapMutations} from 'vuex';
import * as mutations from '../../../../store/commitTypes';
export default {
    components: {
        appPhoneStoreForm: PhoneStoreForm
    },
    props: {
        store: {
            required: true
        }
    },
    data(){
        return {
            fields: [
                {
                    key: 'name',
                    label: 'Nombre',
                    filter: true
                },
                {
                    key: 'number',
                    label: 'Número',
                    filter: true
                },
                {
                    key: 'description',
                    label: 'Descripción',
                    filter: true
                },
                {
                    key: 'actions',
                    label: 'Acciones'
                }
            ],
            selectedPhone: ''
        }   
    },
    computed: {
        ...mapGetters(['selectedStore']),
        tableData(){
            if(!this.store || !this.store.store_phones) return [];
            return this.store.store_phones;
        }
    },
    methods: {
        ...mapMutations({
            setSelectedStore: mutations.SET_SELECTED_STORE
        }),
        startRemovePhone(phone){
            this.selectedPhone = Object.assign({}, phone);
            this.$bus.$emit('store-phone-remove.open');
        },
        startUpdatePhone(phone){
            this.selectedPhone = Object.assign({}, phone);
            this.$bus.$emit('store-phone-form.open');
        },  
        startSavePhone(){
            this.selectedPhone = '';
            this.$bus.$emit('store-phone-form.open');
        },
        onSave(phone) {
            const store = {...this.selectedStore};
            store.store_phones.push(phone);
            this.setSelectedStore(store);
            this.$bus.$emit('store-phone-form.close');
        },
        onEdit(phone) {
            const store = {...this.selectedStore};
            const index = store.store_phones.findIndex(thePhone => parseInt(thePhone.id) === parseInt(phone.id));
            if(-1 != index) {
                store.store_phones.splice(index, 1);
                store.store_phones.push(phone);
                this.setSelectedStore(store);
                this.$bus.$emit('store-phone-form.close');
            }
        },
        deletePhone(phone) {
            const sr = {...storesRepository};
            sr.deleteStorePhone(phone.id)
                .then(({data}) => {
                    if (data.status) {
                        const store = {...this.selectedStore};
                        const index = store.store_phones.findIndex(thePhone => parseInt(thePhone.id) === parseInt(phone.id));
                        if(-1 != index) {
                            store.store_phones.splice(index, 1);
                            this.setSelectedStore(store);

                            toastr.success(data.msg);
                            this.$bus.$emit('store-phone-remove.close');
                        }
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el teléfono');
                });
        },
        cleanForm() {
            this.$bus.$emit('store-phone-form.clean');
        },
    }
}
</script>
